var _defs, _rect, _text, _text2, _text3, _text4, _rect2, _rect3, _text5, _text6, _text7, _text8, _text9, _text10, _line, _rect4, _text11, _text12, _text13, _text14, _text15, _line2, _rect5, _text16, _text17, _text18, _text19, _rect6, _text20, _circle, _text21, _circle2, _text22, _circle3, _text23, _circle4, _text24, _text25;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCase6Fig3CodemodVolumeAndJudgment(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1200 600",
    fontFamily: "Geist, 'Segoe UI', -apple-system, sans-serif",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("marker", {
    id: "arrow",
    viewBox: "0 0 10 10",
    refX: 8,
    refY: 5,
    markerWidth: 8,
    markerHeight: 8,
    orient: "auto"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0 1 L 8 5 L 0 9 Z",
    fill: "#6B7F74"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 1200,
    height: 600,
    fill: "#FFFDF7"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 48,
    y: 52,
    fontSize: 22,
    fontWeight: 600,
    fill: "#1A2F2A"
  }, "The vocabulary migration, volume and judgment")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 48,
    y: 76,
    fontSize: 14,
    fill: "#4A5F56"
  }, "The codemod carried the mechanical part. A person read the diff and carried the rest.")), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 48,
    y: 140,
    fontSize: 32,
    fontWeight: 700,
    fill: "#1A2F2A",
    fontFamily: "'Geist Mono', Consolas, monospace"
  }, "1,004")), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 160,
    y: 140,
    fontSize: 13.5,
    fill: "#4A5F56"
  }, "word-boundary replacements in one codemod pass")), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 158,
    width: 944.5,
    height: 52,
    rx: 4,
    fill: "#16A34A",
    fillOpacity: 0.14,
    stroke: "#16A34A",
    strokeWidth: 1.5
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 992.5,
    y: 158,
    width: 159.5,
    height: 52,
    rx: 4,
    fill: "#DC2626",
    fillOpacity: 0.12,
    stroke: "#DC2626",
    strokeWidth: 1.5
  })), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    x: 72,
    y: 191
  }, /*#__PURE__*/React.createElement("tspan", {
    fontSize: 20,
    fontWeight: 700,
    fill: "#16A34A",
    fontFamily: "'Geist Mono', Consolas, monospace"
  }, "859"), /*#__PURE__*/React.createElement("tspan", {
    fontSize: 13.5,
    fontWeight: 500,
    fill: "#1A2F2A",
    dx: 8
  }, "kept, correct in context"))), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    x: 1072,
    y: 191,
    fontSize: 20,
    fontWeight: 700,
    fill: "#DC2626",
    textAnchor: "middle",
    fontFamily: "'Geist Mono', Consolas, monospace"
  }, "145")), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    x: 1072,
    y: 230,
    fontSize: 12,
    fontWeight: 500,
    fill: "#DC2626",
    textAnchor: "middle"
  }, "hand-reverted")), _text8 || (_text8 = /*#__PURE__*/React.createElement("text", {
    x: 1072,
    y: 246,
    fontSize: 12,
    fontWeight: 500,
    fill: "#DC2626",
    textAnchor: "middle"
  }, "over-reach")), _text9 || (_text9 = /*#__PURE__*/React.createElement("text", {
    x: 48,
    y: 238,
    fontSize: 12,
    fill: "#6B7F74"
  }, "The codemod matched whole words, and whole words still appear in legal names,")), _text10 || (_text10 = /*#__PURE__*/React.createElement("text", {
    x: 48,
    y: 254,
    fontSize: 12,
    fill: "#6B7F74"
  }, "SRE terms of art, and real job titles.")), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 1072,
    y1: 254,
    x2: 1072,
    y2: 298,
    stroke: "#DC2626",
    strokeWidth: 1.5,
    strokeDasharray: "3 3"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 300,
    width: 230,
    height: 180,
    rx: 10,
    fill: "#F5F2E8",
    stroke: "#D4DDD6",
    strokeWidth: 1.5,
    strokeDasharray: "6 4"
  })), _text11 || (_text11 = /*#__PURE__*/React.createElement("text", {
    x: 68,
    y: 330,
    fontSize: 11,
    fontWeight: 600,
    letterSpacing: "0.1em",
    fill: "#6B7F74"
  }, "RETIRED TERMS")), _text12 || (_text12 = /*#__PURE__*/React.createElement("text", {
    x: 68,
    y: 360,
    fontSize: 15,
    fill: "#6B7F74",
    textDecoration: "line-through"
  }, "service")), _text13 || (_text13 = /*#__PURE__*/React.createElement("text", {
    x: 68,
    y: 388,
    fontSize: 15,
    fill: "#6B7F74",
    textDecoration: "line-through"
  }, "atom")), _text14 || (_text14 = /*#__PURE__*/React.createElement("text", {
    x: 68,
    y: 416,
    fontSize: 15,
    fill: "#6B7F74",
    textDecoration: "line-through"
  }, "job")), _text15 || (_text15 = /*#__PURE__*/React.createElement("text", {
    x: 68,
    y: 444,
    fontSize: 15,
    fill: "#6B7F74",
    textDecoration: "line-through"
  }, "recipe")), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 288,
    y1: 390,
    x2: 324,
    y2: 390,
    stroke: "#6B7F74",
    strokeWidth: 1.5,
    strokeDasharray: "3 3",
    markerEnd: "url(#arrow)"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 338,
    y: 300,
    width: 230,
    height: 180,
    rx: 10,
    fill: "#FFFFFF",
    stroke: "#16A34A",
    strokeWidth: 2
  })), _text16 || (_text16 = /*#__PURE__*/React.createElement("text", {
    x: 358,
    y: 330,
    fontSize: 11,
    fontWeight: 600,
    letterSpacing: "0.1em",
    fill: "#16A34A"
  }, "LOCKED VOCABULARY")), _text17 || (_text17 = /*#__PURE__*/React.createElement("text", {
    x: 358,
    y: 366,
    fontSize: 15.5,
    fontWeight: 600,
    fill: "#1A2F2A"
  }, "play")), _text18 || (_text18 = /*#__PURE__*/React.createElement("text", {
    x: 358,
    y: 400,
    fontSize: 15.5,
    fontWeight: 600,
    fill: "#1A2F2A"
  }, "operation")), _text19 || (_text19 = /*#__PURE__*/React.createElement("text", {
    x: 358,
    y: 434,
    fontSize: 15.5,
    fontWeight: 600,
    fill: "#1A2F2A"
  }, "playbook")), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 620,
    y: 300,
    width: 532,
    height: 180,
    rx: 10,
    fill: "#F5F2E8",
    stroke: "#D4DDD6",
    strokeWidth: 1.5,
    strokeDasharray: "6 4"
  })), _text20 || (_text20 = /*#__PURE__*/React.createElement("text", {
    x: 644,
    y: 330,
    fontSize: 11,
    fontWeight: 600,
    letterSpacing: "0.1em",
    fill: "#DC2626"
  }, "FOUR NAMED OVER-REACHES, READ BACK BY HAND")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 650,
    cy: 356,
    r: 3,
    fill: "#DC2626"
  })), _text21 || (_text21 = /*#__PURE__*/React.createElement("text", {
    x: 664,
    y: 360,
    fontSize: 13,
    fill: "#1A2F2A"
  }, "Master Services Agreement, a legal document title")), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 650,
    cy: 386,
    r: 3,
    fill: "#DC2626"
  })), _text22 || (_text22 = /*#__PURE__*/React.createElement("text", {
    x: 664,
    y: 390,
    fontSize: 13,
    fill: "#1A2F2A"
  }, "SRE service level objectives, a term of art")), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 650,
    cy: 416,
    r: 3,
    fill: "#DC2626"
  })), _text23 || (_text23 = /*#__PURE__*/React.createElement("text", {
    x: 664,
    y: 420,
    fontSize: 13,
    fill: "#1A2F2A"
  }, "HR job descriptions, listings for actual jobs")), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 650,
    cy: 446,
    r: 3,
    fill: "#DC2626"
  })), _text24 || (_text24 = /*#__PURE__*/React.createElement("text", {
    x: 664,
    y: 450,
    fontSize: 13,
    fill: "#1A2F2A"
  }, "the manifesto's human \"job\", a person's work")), _text25 || (_text25 = /*#__PURE__*/React.createElement("text", {
    x: 48,
    y: 548,
    fontSize: 13.5,
    fontWeight: 500,
    fill: "#1A2F2A"
  }, "1,004 mechanical edits in one pass, 145 human reversals after reading the diff, both parts of the same migration.")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCase6Fig3CodemodVolumeAndJudgment);
export default __webpack_public_path__ + "static/media/case6-fig3-codemod-volume-and-judgment.3bd1a2c40d2e64051602648953845a16.svg";
export { ForwardRef as ReactComponent };